import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "link-text" }

import { PropType } from "vue";

import { useUIGeneralStore } from "@/stores/ui-general.store";

import { SidebarNavigationLink } from "@/models/sidebar.model";


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarLink',
  props: {
  link: {
    required: true,
    type: Object as PropType<SidebarNavigationLink>
  }
},
  setup(__props) {

const uiGeneralStore = useUIGeneralStore();



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: __props.link.to,
    class: _normalizeClass([
      'sidebar-link',
      {
        highlighted: __props.link.isHighlighted,
        'not-available': __props.link.isNotAvailable,
        open: _unref(uiGeneralStore).isSidebarOpen
      }
    ]),
    "data-testing": __props.link.dataTesting
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: "sidebar-icon",
        title: __props.link.title
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.link.title), 1)
    ]),
    _: 3
  }, 8, ["to", "class", "data-testing"]))
}
}

})